import React, { useEffect, useState } from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { WHATSAPP_MESSAGES } from '../config/siteConfig';
import { createWhatsAppUrl, trackEvent } from '../utils/analytics';
export function FloatingWhatsApp() {
  const [isVisible, setIsVisible] = useState(false);
  const [isPriceVisible, setIsPriceVisible] = useState(false);
  const isRestaurantRoute = window.location.pathname.replace(/\/+$/, '').endsWith('/restaurantes');
  const message = isRestaurantRoute ? WHATSAPP_MESSAGES.restaurant : WHATSAPP_MESSAGES.general;
  useEffect(() => {
    function onScroll() {
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      setIsVisible(maxScroll > 0 && window.scrollY / maxScroll >= 0.2);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    const priceSection = document.getElementById('precio');
    if (!priceSection || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(([entry]) => setIsPriceVisible(entry.isIntersecting), {
      threshold: 0.16
    });
    observer.observe(priceSection);
    return () => observer.disconnect();
  }, []);
  if (!isVisible || isPriceVisible) return null;
  return <a href={createWhatsAppUrl(message)} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent(isRestaurantRoute ? 'whatsapp_restaurant_click' : 'whatsapp_floating_click', {
    cta_location: 'floating'
  })} aria-label="Consultar por WhatsApp" className="fixed bottom-[calc(1rem+env(safe-area-inset-bottom))] right-4 z-40 inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25d366] text-[#06170c] shadow-lg shadow-black/30 transition-transform hover:scale-105 focus:outline-none focus-visible:ring-2 focus-visible:ring-white md:bottom-6 md:right-6 md:h-auto md:w-auto md:min-h-12 md:px-4" data-id="element-915">
      <MessageCircleIcon className="h-5 w-5 flex-none" data-id="element-916" />
      <span className="hidden text-sm font-semibold md:inline" data-id="element-917">
        Consultar por WhatsApp
      </span>
    </a>;
}